module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "green",
      "data-image": "../../assets/img/sidebar-5.jpg"
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user border-0"
  }, [_c('div', {
    staticClass: "info ml-4"
  }, [_c('span', {
    attrs: {
      "id": "myname"
    }
  }, [_vm._v(_vm._s(_vm.myself))])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink2"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": function($event) {
        return _vm.addRFQ();
      }
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("CREATE RFQ")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-background",
    staticStyle: {
      "background-image": "url(../static/img/sidebar-5.jpg)"
    }
  })]), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-fluid p-4",
    attrs: {
      "src": require("../../assets/raefton-logo.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink3"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/contact/edit"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("MY PROFILE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink1"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/rfq/assets"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-bus-front-12"
  }), _vm._v(" "), _c('p', [_vm._v("Assets")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink1"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/rfq/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-delivery-fast"
  }), _vm._v(" "), _c('p', [_vm._v("RFQs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink4"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/shipment/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("SHIPMENTS "), _c('span', {
    attrs: {
      "id": "num_shippments"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink3"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/contact/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("CONTACTS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/auth/login"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-button-power"
  }), _vm._v(" "), _c('p', [_vm._v("SIGN OUT")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-panel"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg "
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "navbar-minimize"
  }, [_c('button', {
    staticClass: "btn btn-success btn-fill btn-round btn-icon d-none d-lg-block",
    attrs: {
      "id": "minimizeSidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v visible-on-sidebar-regular"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-navicon visible-on-sidebar-mini"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#pablo",
      "id": "test"
    }
  }, [_vm._v(" Assets")])]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "aria-controls": "navigation-index",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  }), _vm._v(" "), _c('span', {
    staticClass: "navbar-toggler-bar burger-lines"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("You don't currently have any assets added. Please click one of the Add buttons to get started.")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Tractor")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Trailer")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card data-tables"
  }, [_c('div', {
    staticClass: "card-body table-no-bordered dataTable dtr-inline table-full-width"
  }, [_c('div', {
    staticClass: "fresh-datatables"
  }, [_c('table', {
    staticClass: "table table-striped table-no-bordered table-hover",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "datatables_contacts",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Make")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: " text-right"
  }, [_vm._v("Actions")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "align-top"
  }, [_vm._v("Volvo")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("VNR")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("200112")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("Tractor")]), _vm._v(" "), _c('td', {
    staticClass: " text-right"
  }, [_c('a', {
    staticClass: "btn btn-link btn-info",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil"
  })]), _c('a', {
    staticClass: "btn btn-link btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "align-top"
  }, [_vm._v("Volvo")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("VNR")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("342123")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("Tractor")]), _vm._v(" "), _c('td', {
    staticClass: " text-right"
  }, [_c('a', {
    staticClass: "btn btn-link btn-info",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil"
  })]), _c('a', {
    staticClass: "btn btn-link btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "align-top"
  }, [_vm._v("Great Dane")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("Freedom SE")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("332938")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("Trailer")]), _vm._v(" "), _c('td', {
    staticClass: " text-right"
  }, [_c('a', {
    staticClass: "btn btn-link btn-info",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil"
  })]), _c('a', {
    staticClass: "btn btn-link btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "align-top"
  }, [_vm._v("Great Dane")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("Freedom SE")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("74443")]), _vm._v(" "), _c('td', {
    staticClass: "align-top"
  }, [_vm._v("Trailer")]), _vm._v(" "), _c('td', {
    staticClass: " text-right"
  }, [_c('a', {
    staticClass: "btn btn-link btn-info",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-pencil"
  })]), _c('a', {
    staticClass: "btn btn-link btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash"
  })])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Tractor")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-wd"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add a Trailer")])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', [_c('p', {
    staticClass: "copyright text-center"
  }, [_vm._v("\n            © 2018 Raefton\n          ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7113608"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/raw_templates/t_assets.vue
// module id = 780
// module chunks = 0